import React, { useState, useCallback } from 'react'
import { Pagination } from 'react-angle-dashboard-components'

export interface IDirectoryPaginationProps {
  page: number
  amountOfRecords: number
  setPage: Function
  perPage: number
  onSetPageLimit?: Function
}

export const DirectoryPagination: React.FC<IDirectoryPaginationProps> = ({
  page,
  setPage,
  amountOfRecords,
  perPage,
  onSetPageLimit = (numberOfRecords: number) => {},
}) => {
  // At the moment this does not change the actual page limit of the parent,
  // a setter function might be passed from the parent for that
  const [itemsPerPage, setPageLimit] = useState(perPage)

  const totalPages = Math.ceil(amountOfRecords / itemsPerPage)

  const handlePageLimitChange = useCallback((pageLimit: number) => {
    setPageLimit(pageLimit);
    onSetPageLimit(pageLimit);
  }, [onSetPageLimit])

  const paginationConfig = {
    totalPages: totalPages,
    currentPage: page,
    setPage: setPage,
    totalItems: amountOfRecords,
    pageLimit: itemsPerPage,
    setPageLimit: handlePageLimitChange,
    pageNumberList: [25, 50, 100]
  }

  return (
    <div>
      <Pagination {...paginationConfig} />
    </div>
  )
}

export default DirectoryPagination
